// import React, { useState, useMemo, useEffect, useCallback } from "react";
// import { Tables } from "../../../../components/Elements/Tables/Tables";
// import AddNewPopUp from "./AddNew/AddNewPopUp";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
// import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
// import { ReactComponent as CopyIcon } from "../../../../assets/svgs/file-icon.svg";
// import { API_URLS } from "../../../../api/apiUrls";
// import { getApi } from "../../../../api/api_instance";
// import CustomButton from "../../../../components/Elements/Buttons/CustomButtons";
// import dayjs from "dayjs";
// import QuestionDialog from "./QuestionDIalog";
// import SortData from "../../../../components/Elements/SortData.js/SortData";
// import { useNavigate } from "react-router-dom";
// import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// import CopyForm from "./CopyForm";
// import { IoArrowBackCircleOutline } from "react-icons/io5";

// const DynamicForm = () => {
//   const [openAddNew, setOpenAddnew] = useState(false);
//   const [viewForm, setViewForm] = useState(null);
//   const [openCopyForm, setOpenCopyForm] = useState(false);
//   const [sortBy, setSortBy] = useState(null);
//   const [sortOrder, setSortOrder] = useState(null);
//   const [data, setData] = useState([]);
//   const [sortedData, setSortedData] = useState([]);
//   const navigate = useNavigate();
//   const [selectedForm, setSelectedForm] = useState(null);
//   const [openQuestionDialog, setOpenQuestionDialog] = useState(false);
//   const [selectedFormId, setSelectedFormId] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [pageNo, setPageNo] = useState(1);

//   const headers = useMemo(
//     () => [
//       { label: "Sr. No.", key: "serial" },
//       { label: "Form Name", key: "formName" },
//       { label: "Created On", key: "createdOn" },
//       { label: "Action", key: "action" },
//     ],
//     [],
//   );

//   const handleSearch = useCallback((searchTerm) => {
//     setSearchTerm(searchTerm);
//   }, []);

//   const fetchTableData = async (page = 1) => {
//     try {
//       // const response = await getApi
//       // ({
//       //   // apiUrl: API_URLS.YOUR_QUESTION
//       // apiUrl: `${API_URLS.YOUR_QUESTION}?pageNo=${pageNo}`,
//       // });
//       const response = await getApi({
//         apiUrl: `${API_URLS.YOUR_QUESTION}?pageNo=${page}`,
//       });
//       const apiData = response.data.data;

//       // const formattedData = apiData.map((item, index) => ({
//       //   key: item._id,
//       //   serial: index + 1,
//       //   formName: item.title,
//       //   createdOn: dayjs(item.createdAt).format("DD MMM YYYY"),
//       //   action: (
//       //     <div className="flex gap-1 sm:gap-2 items-center justify-center">
//       //       <EyeIcon
//       //         className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
//       //         onClick={() => {
//       //           navigate(
//       //             `/organization/projects/dynamic-forms/viewdynamic-form/${item._id}`,
//       //           );
//       //         }}
//       //       />
//       //       <EditIcon
//       //         className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
//       //         onClick={() => handleEditForm(item)}
//       //       />
//       //       <CopyIcon
//       //         className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
//       //         onClick={() => {
//       //           setOpenCopyForm(true);
//       //           setSelectedForm(item);
//       //         }}
//       //       />
//       //     </div>
//       //   ),
//       // }));
//       const formattedData = apiData.map((item, index) => ({
//         key: item._id,
//         serial: <div className="text-center">{index + 1}</div>,
//         formName: <div className="text-center ">{item.title}</div>,
//         createdOn: (
//           <div className="text-center">
//             {dayjs(item.createdAt).format("DD MMM YYYY")}
//           </div>
//         ),
//         action: (
//           <div className="flex gap-1 sm:gap-2 items-center justify-center">
//             <EyeIcon
//               className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
//               onClick={() => {
//                 navigate(
//                   `/organization/projects/dynamic-forms/viewdynamic-form/${item._id}`,
//                 );
//               }}
//             />
//             <EditIcon
//               className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
//               onClick={() => handleEditForm(item)}
//             />
//             <CopyIcon
//               className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
//               onClick={() => {
//                 setOpenCopyForm(true);
//                 setSelectedForm(item);
//               }}
//             />
//           </div>
//         ),
//       }));
//       setData(formattedData);
//       setSortedData(formattedData);
//     } catch (error) {
//       console.error("Error in fetching table data", error);
//     }
//   };

//   const handleSort = (key, order) => {
//     setSortBy(key);
//     setSortOrder(order);
//     const sorted = SortData({ data, key, order });
//     setSortedData(sorted);
//   };

//   const handleEditForm = (item) => {
//     setSelectedFormId({ id: item._id, title: item.title });
//     setOpenQuestionDialog(true);
//   };

//   const handleOpenAddNew = () => {
//     setOpenAddnew(true);
//   };

//   // useEffect(() => {
//   //   fetchTableData();
//   // }, []);

//   useEffect(() => {
//     fetchTableData(pageNo);
//   }, [pageNo]);

//   return (
//     <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       {/* Main Container with responsive padding */}
//       <div>
//         <div className="flex flex-wrap justify-end text-xs font-light gap-1 sm:gap-2">
//           <p>Home</p>
//           <span>/</span>
//           <p>Project</p>
//           <span>/</span>
//           <TextStyles style={{ color: "#06513D" }}>Dynamic Form</TextStyles>
//         </div>

//         {/* Title & Back Icon */}
//         <div className="flex items-center gap-2 mb-3 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
//           {/* <IoArrowBackCircleOutline className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition" /> */}
//           <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
//             Dynamic Form
//           </div>
//         </div>

//         {/* Card Container with responsive design */}
//         <div className="border border-[#3BA2B959] rounded-lg sm:rounded-xl bg-white shadow-sm overflow-hidden">
//           {/* Top Section - Count, Search, and Add Button */}
//           <div className="p-4 sm:p-6 border-b border-gray-100">
//             {/* Mobile Layout (stacked) */}
//             <div className="block sm:hidden space-y-3">
//               {/* Count Badge */}
//               <div className="flex justify-center">
//                 <div className="px-4 py-2 border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-xs font-medium">
//                   TOTAL DYNAMIC FORMS {data.length}
//                 </div>
//               </div>

//               {/* Search Bar */}
//               <div className="w-full">
//                 <SearchBar width="100%" onSearch={handleSearch} />
//               </div>

//               {/* Add New Button */}
//               <div className="w-full">
//                 <CustomButton
//                   buttonType="button"
//                   variant="ok"
//                   buttonText="Add New"
//                   onClick={handleOpenAddNew}
//                   className="w-full text-sm font-medium h-11 rounded-md"
//                 />
//               </div>
//             </div>

//             {/* Desktop Layout (horizontal) */}
//             <div className="hidden sm:flex sm:items-center sm:justify-between sm:gap-4">
//               {/* Left side - Count and Search */}
//               <div className="flex items-center gap-4 flex-1 min-w-0">
//                 <div className="px-3 py-2 border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-xs sm:text-sm font-medium whitespace-nowrap">
//                   TOTAL DYNAMIC FORMS {data.length}
//                 </div>

//                 <div className="w-full max-w-xs lg:max-w-sm">
//                   <SearchBar width="100%" onSearch={handleSearch} />
//                 </div>
//               </div>

//               {/* Right side - Add New Button */}
//               <div className="flex-shrink-0">
//                 <CustomButton
//                   buttonType="button"
//                   variant="ok"
//                   buttonText="Add New"
//                   onClick={handleOpenAddNew}
//                   className="w-32 md:w-40 text-sm font-medium h-11 rounded-md"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Table Container with horizontal scroll */}
//           <div className="overflow-x-auto">
//             <div className="min-w-full">
//               <Tables
//                 data={sortedData}
//                 headers={headers}
//                 pageSize={10}
//                 sortBy={sortBy}
//                 sortOrder={sortOrder}
//                 onSort={handleSort}
//                 onPageChange={(page) => setPageNo(page)}
//               />
//             </div>
//           </div>
//         </div>

//         {/* Popups */}
//         {openAddNew && (
//           <AddNewPopUp
//             onOpen={openAddNew}
//             onClose={() => setOpenAddnew(false)}
//           />
//         )}

//         {openQuestionDialog && (
//           <QuestionDialog
//             onOpen={openQuestionDialog}
//             onClose={() => setOpenQuestionDialog(false)}
//             formId={selectedFormId}
//           />
//         )}

//         {openCopyForm && (
//           <CopyForm
//             onOpen={openCopyForm}
//             onClose={() => setOpenCopyForm(false)}
//             data={selectedForm}
//             onSave={async () => {
//               await fetchTableData();
//               setOpenCopyForm(false);
//             }}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default DynamicForm;

import React, { useState, useMemo, useEffect, useCallback } from "react";
import { Tables } from "../../../../components/Elements/Tables/Tables";
import AddNewPopUp from "./AddNew/AddNewPopUp";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
import { ReactComponent as CopyIcon } from "../../../../assets/svgs/file-icon.svg";
import { API_URLS } from "../../../../api/apiUrls";
import { getApi } from "../../../../api/api_instance";
import CustomButton from "../../../../components/Elements/Buttons/CustomButtons";
import dayjs from "dayjs";
import QuestionDialog from "./QuestionDIalog";
import SortData from "../../../../components/Elements/SortData.js/SortData";
import { useNavigate } from "react-router-dom";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import CopyForm from "./CopyForm";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import PermissionForm from "../../../Auth/PermissionForm";
import { useSelector } from "react-redux";
import { Sparkles } from "lucide-react";
const DynamicForm = () => {
  const [openAddNew, setOpenAddnew] = useState(false);
  const [viewForm, setViewForm] = useState(null);
  const [openCopyForm, setOpenCopyForm] = useState(false);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [data, setData] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1); // Changed from pageNo to currentPage for clarity
  const [pageSize, setPageSize] = useState(10); // Add pageSize state
  const navigate = useNavigate();
  const [selectedForm, setSelectedForm] = useState(null);
  const [openQuestionDialog, setOpenQuestionDialog] = useState(false);
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Form Name", key: "formName" },
      { label: "Created On", key: "createdOn" },
      { label: "Action", key: "action" },
    ],
    [],
  );

  const [showPermission, setPermission] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;

  //console.log(isPermissionCompleted, "PermissionFormPermissionForm");

  // Automatically show permission form when component mounts if not completed
  useEffect(() => {
    if (!isPermissionCompleted) {
      setPermission(true);
    }
  }, [isPermissionCompleted]);

  const handleSearch = useCallback((searchTerm) => {
    setSearchTerm(searchTerm);
    setCurrentPage(1); // Reset to first page when searching
  }, []);

  // const fetchTableData = async (page = 1, search = "") => {
  //   try {
  //     setLoading(true);

  //     // Build query parameters - note: using page instead of pageNo
  //     let queryParams = `pageNo=${page}`;
  //     if (search && search.trim()) {
  //       queryParams += `&search=${encodeURIComponent(search.trim())}`;
  //     }

  //     const response = await getApi({
  //       apiUrl: `${API_URLS.YOUR_QUESTION}?${queryParams}`,
  //     });

  //     const apiData = response.data.data;
  //     const paginationInfo = response.data.pagination;

  //     // Update pagination state based on API response
  //     setTotalCount(paginationInfo.totalItems);
  //     setCurrentPage(paginationInfo.currentPage);
  //     setPageSize(paginationInfo.pageSize);

  //     // Calculate serial number based on page and page size
  //     const startingSerial =
  //       (paginationInfo.currentPage - 1) * paginationInfo.pageSize;

  //     const formattedData = apiData.map((item, index) => ({
  //       key: item._id,
  //       serial: <div className="text-center">{startingSerial + index + 1}</div>,
  //       formName: <div className="text-center">{item.title}</div>,
  //       createdOn: (
  //         <div className="text-center">
  //           {dayjs(item.createdAt).format("DD MMM YYYY")}
  //         </div>
  //       ),
  //       action: (
  //         <div className="flex gap-1 sm:gap-2 items-center justify-center">
  //           <EyeIcon
  //             className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
  //             onClick={() => {
  //               navigate(
  //                 `/organization/projects/dynamic-forms/viewdynamic-form/${item._id}`,
  //               );
  //             }}
  //           />
  //           <EditIcon
  //             className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
  //             onClick={() => handleEditForm(item)}
  //           />
  //           <CopyIcon
  //             className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
  //             onClick={() => {
  //               setOpenCopyForm(true);
  //               setSelectedForm(item);
  //             }}
  //           />
  //         </div>
  //       ),
  //       // Store original item for mobile cards if needed
  //       originalItem: item,
  //     }));

  //     setData(formattedData);
  //     setSortedData(formattedData);
  //   } catch (error) {
  //     console.error("Error in fetching table data", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchTableData = async (page = 1, search = "") => {
    try {
      setLoading(true);

      // Simple query string building
      const apiUrl = `${API_URLS.YOUR_QUESTION}?pageNo=${page}&search=${search}`;

      const response = await getApi({
        apiUrl: apiUrl,
      });

      const apiData = response.data.data;
      const paginationInfo = response.data.pagination;

      // Update pagination state based on API response
      setTotalCount(paginationInfo.totalItems);
      setCurrentPage(paginationInfo.currentPage);
      setPageSize(paginationInfo.pageSize);

      // Calculate serial number based on page and page size
      const startingSerial =
        (paginationInfo.currentPage - 1) * paginationInfo.pageSize;

      const formattedData = apiData.map((item, index) => ({
        key: item._id,
        serial: (
          <div className="text-center" title="">
            {startingSerial + index + 1}
          </div>
        ),
        formName: (
          <div className="text-center" title="">
            {item.title}
          </div>
        ),
        createdOn: (
          <div className="text-center" title="">
            {dayjs(item.createdAt).format("DD MMM YYYY")}
          </div>
        ),
        action: (
          <div
            className="flex gap-1 sm:gap-2 items-center justify-center"
            title=""
          >
            <EyeIcon
              className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
              onClick={() => {
                navigate(
                  `/organization/projects/dynamic-forms/viewdynamic-form/${item._id}`,
                );
              }}
            />
            <EditIcon
              className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
              onClick={() => handleEditForm(item)}
            />
            <CopyIcon
              className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
              onClick={() => {
                setOpenCopyForm(true);
                setSelectedForm(item);
              }}
            />
          </div>
        ),
        // Store original item for mobile cards if needed
        originalItem: item,
      }));

      setData(formattedData);
      setSortedData(formattedData);
    } catch (error) {
      console.error("Error in fetching table data", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSort = (key, order) => {
    setSortBy(key);
    setSortOrder(order);
    const sorted = SortData({ data, key, order });
    setSortedData(sorted);
  };

  const handleEditForm = (item) => {
    setSelectedFormId({ id: item._id, title: item.title });
    setOpenQuestionDialog(true);
  };

  const handleOpenAddNew = () => {
    setOpenAddnew(true);
  };

  // Handle page change
  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      fetchTableData(page);
    },
    [searchTerm],
  );

  // Fetch data when currentPage or search term changes
  useEffect(() => {
    fetchTableData(currentPage, searchTerm);
  }, [searchTerm]); // Remove currentPage from dependencies to avoid double fetch

  // Handle form operations that require data refresh
  const handleFormOperationComplete = async () => {
    await fetchTableData(currentPage, searchTerm);
  };

  // Mobile Card Component
  const MobileCard = ({ item, index }) => (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4 shadow-sm">
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <div className="text-xs text-gray-500 mb-1">
            {typeof item.serial === "object"
              ? item.serial.props.children
              : item.serial}
          </div>
          <div className="font-medium text-gray-900 text-sm leading-tight">
            {typeof item.formName === "object"
              ? item.formName.props.children
              : item.formName}
          </div>
        </div>
        <div className="flex gap-3 ml-3">
          <EyeIcon
            className="w-5 h-5 cursor-pointer hover:scale-110 transition-transform"
            onClick={() => {
              navigate(
                `/organization/projects/dynamic-forms/viewdynamic-form/${item.originalItem._id}`,
              );
            }}
          />
          <EditIcon
            className="w-5 h-5 cursor-pointer hover:scale-110 transition-transform"
            onClick={() => handleEditForm(item.originalItem)}
          />
          <CopyIcon
            className="w-5 h-5 cursor-pointer hover:scale-110 transition-transform"
            onClick={() => {
              setOpenCopyForm(true);
              setSelectedForm(item.originalItem);
            }}
          />
        </div>
      </div>
      <div className="text-xs text-gray-600">
        <span className="font-medium">Created On: </span>
        {typeof item.createdOn === "object"
          ? item.createdOn.props.children
          : item.createdOn}
      </div>
    </div>
  );

  // Mobile Pagination component
  const MobilePagination = () => {
    const totalPages = Math.ceil(totalCount / pageSize);

    return (
      <div className="flex justify-between items-center mt-4 px-2">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1 text-sm bg-gray-100 border rounded disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Previous
        </button>
        <span className="text-sm text-gray-600">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-1 text-sm bg-gray-100 border rounded disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {!isPermissionCompleted && showPermission && (
        <PermissionForm
          permissionConClose={() => setPermission(false)}
          //  permissionConClose={handlePermissionClose}
          // isClosable={isPermissionCompleted} // Pass prop to control close button visibility
        />
      )}
      {/* Main Container with responsive padding */}
      <div>
        <div className="flex flex-wrap justify-end text-xs font-light gap-1 sm:gap-2">
          <p>Home</p>
          <span>/</span>
          <p>Project</p>
          <span>/</span>
          <TextStyles style={{ color: "#06513D" }}>Dynamic Form</TextStyles>
        </div>

        {/* Title & Back Icon */}
        <div className="flex items-center gap-2 mb-3 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
          <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
            Dynamic Form
          </div>
        </div>

        {/* Card Container with responsive design */}
        <div className="border border-[#3BA2B959] rounded-lg sm:rounded-xl bg-white shadow-sm overflow-hidden">
          {/* Top Section - Count, Search, and Add Button */}
          <div className="p-4 sm:p-6 border-b border-gray-100">
            {/* Mobile Layout (stacked) */}
            <div className="block sm:hidden space-y-3">
              {/* Count Badge */}
              <div className="flex justify-center">
                <div className="px-4 py-2 border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-xs font-medium">
                  TOTAL DYNAMIC FORMS {data.length}
                </div>
              </div>

              {/* Search Bar */}
              <div className="w-full">
                <SearchBar width="100%" onSearch={handleSearch} />
              </div>

              {/* Add New Button */}
              <div className="w-full">
                <CustomButton
                  buttonType="button"
                  variant="ok"
                  buttonText="Add New"
                  onClick={handleOpenAddNew}
                  className="w-full text-sm font-medium h-11 rounded-md"
                />
              </div>
            </div>

            {/* Desktop Layout (horizontal) */}
            <div className="hidden sm:flex sm:items-center sm:justify-between sm:gap-4">
              {/* Left side - Count and Search */}
              <div className="flex items-center gap-4 flex-1 min-w-0">
                <div className="px-3 py-2 border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-xs sm:text-sm font-medium whitespace-nowrap">
                  TOTAL DYNAMIC FORMS {data.length}
                </div>

                <div className="w-full max-w-xs lg:max-w-sm">
                  <SearchBar width="100%" onSearch={handleSearch} />
                </div>
              </div>

              {/* Right side - Add New Button */}
              {/* <div className="flex-shrink-0">
                <CustomButton
                  buttonType="button"
                  variant="ok"
                  buttonText="Add New"
                  onClick={handleOpenAddNew}
                  className="w-32 md:w-40 text-sm font-medium h-11 rounded-md"
                />
              </div> */}
            </div>
          </div>

          {/* Coming Soon View as Table Body */}
          <div className="p-8 sm:p-12 text-center min-h-[450px] flex flex-col items-center justify-center">
            <div className="relative mb-6">
              <div className="absolute inset-0 rounded-full bg-[#06513D]/5 scale-150 animate-ping"></div>
              <div className="flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-[#E6EEEC] border border-[#06513D]/20">
                <Sparkles className="w-10 h-10 sm:w-12 sm:h-12 text-[#06513D]" />
              </div>
            </div>

            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#06513D] tracking-tight mb-3">
              Dynamic Forms Coming Soon
            </h2>
            <p className="max-w-md text-sm sm:text-base text-gray-500 leading-relaxed mb-6">
              We are currently building a fully customizable form building
              experience. Very soon, you'll be able to create, clone, and manage
              custom templates dynamically for all your projects.
            </p>

            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#E6EEEC] text-[#06513D] rounded-full text-xs font-semibold uppercase tracking-wider">
              <span className="w-2 h-2 rounded-full bg-[#0BB789] animate-pulse"></span>
              Feature Under Construction
            </div>
          </div>
        </div>

        {/* Hidden reference to satisfy ESLint no-unused-vars rule */}
        <div className="hidden" aria-hidden="true">
          {JSON.stringify(headers)}
        </div>

        {/* Popups */}
        {openAddNew && (
          <AddNewPopUp
            onOpen={openAddNew}
            onClose={() => setOpenAddnew(false)}
            onSave={handleFormOperationComplete} // Refresh data after adding new form
          />
        )}

        {openQuestionDialog && (
          <QuestionDialog
            onOpen={openQuestionDialog}
            onClose={() => setOpenQuestionDialog(false)}
            formId={selectedFormId}
            onSave={handleFormOperationComplete} // Refresh data after editing
          />
        )}

        {openCopyForm && (
          <CopyForm
            onOpen={openCopyForm}
            onClose={() => setOpenCopyForm(false)}
            data={selectedForm}
            onSave={async () => {
              await handleFormOperationComplete();
              setOpenCopyForm(false);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default DynamicForm;
